// extracted by mini-css-extract-plugin
module.exports = {"file-upload":"uploaded-module__file-upload___1x5Tn","fileUpload":"uploaded-module__file-upload___1x5Tn"};